<template>
  <div class="c-table-cell">
    <div class="c-table-cell__wrapper cell-filial-settings">
      <c-popup
        v-if="cellValue && localFilialSettings.length !== 0"
        class="cell-filial-settings__icon"
        :cell-index="cellIndex"
        :post-code="postCode"
        :title="column.fullName"
        :scrollable="localFilialSettings.length > 6"
        popup-position="right"
        :popup-items="localFilialSettings"
      />
      <div class="cell-filial-settings__value">
        {{ cellValue }}
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/pages/positions/data-table/filial-settings-popover";

export default {
  name: "c-table-cell",

  components: {
    "c-popup": Popup,
  },
  props: ["filialSettings", "cellValue", "column", "postCode", "cellIndex"],

  data() {
    return {
      localFilialSettings: [],
      localLoadType: "",
    };
  },

  mounted() {
    this.getFilialSettingsByColumnId();
  },

  methods: {
    getFilialSettingsByColumnId() {
      this.filialSettings.forEach((filial) => {
        if (filial[this.column.id] !== null && filial[this.column.id] !== undefined) {
          if (filial.filial_name !== null) {
            this.localFilialSettings.push({
              name: filial.filial_name,
              value: !filial[this.column.id] ? this.cellValue : filial[this.column.id],
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table-cell {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 13px;

  .cell-filial-settings {
    padding: 10px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    &__icon {
      transition: 0.3s;
      cursor: pointer;
    }

    &__value {
      line-height: 13px;
      font-size: 13px;
      transition: font 0.3s ease;
    }
  }
}
</style>
